document.addEventListener("latte:init", init);
var gtm = require('./gtm-events');

var promoCounterInterval;

var pageURL = window.location.href;

function init () {
    $(document).on('opening', '.remodal', function () {
        gtm.analyticsEvent('button click', 'promo banner', pageURL);
    });


    $('.js-promo-code-copy').click(function () {
        copyButton = this;
        copyPromoElement = copyButton.parentElement.getElementsByTagName('input')[0];
        gtm.analyticsEvent('button click', 'copy promo code', pageURL + ' ' + copyPromoElement.value);

        var iOSMatch = new RegExp(/(iPod|iPhone|iPad)/);

        if (iOSMatch.test(navigator.userAgent) && typeof navigator.userAgent !== 'undefined') {
            var el = copyPromoElement;
            var oldContentEditable = el.contentEditable,
                oldReadOnly = el.readOnly,
                range = document.createRange();

            el.contentEditable = true;
            el.readOnly = false;
            range.selectNodeContents(el);

            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);

            el.setSelectionRange(0, 999999);

            el.contentEditable = oldContentEditable;
            el.readOnly = oldReadOnly;
        } else {
            copyPromoElement.select();
        }

        document.execCommand('copy');
        copyPromoElement.blur();

        $('.js-promo-code-copy').each(function () {
            $(this).find('p').text('COPY');
            $(this).removeClass('copied');
        })
        $(copyButton).find('p').text('COPIED');
        $(copyButton).addClass('copied');
    })

    $('.close-promo-btn').click(function (e) {
        e.stopPropagation();
        var inst = $('[data-remodal-id=promo-modal]').remodal();
        if (inst) {
            inst.destroy();
        }

        sessionStorage && sessionStorage.setItem('showPromo', false);
        $('.promo-bar').hide();
    });

    promoHeight = $('.promo').height();
    barHeight = $('.promo-background').height();


    startTime = moment($('.promo-top').attr('data-start-date'), "ddd MMMM D YYYY H:m:s Z") ? moment($('.promo-top').attr('data-start-date'), "ddd MMMM D YYYY H:m:s Z") : 0;
    endTime = moment($('.promo-top').attr('data-end-date'), "ddd MMMM D YYYY H:m:s Z") ? moment($('.promo-top').attr('data-end-date'), "ddd MMMM D YYYY H:m:s Z") : 0;

    var currentTime = moment();

    if (moment(currentTime).isBetween(startTime, endTime) && endTime.diff(currentTime, 'hours') <= 72) {
        $('.promo-end-date-text').hide();

        //var hours = endTime.diff(currentTime, 'hours');
        var difference = endTime.diff(currentTime);
        var duration = moment.duration(difference);
        var interval = 1000;

        //clearing promo counter
        if (promoCounterInterval) {
            clearInterval(promoCounterInterval);
        }

        promoCounterInterval = setInterval(function () {
            $('.promo-counter').css({ 'display': 'inline' });
            $('.show-promo-details-link').remove();
            duration = moment.duration(duration - interval, 'milliseconds');
            if (duration <= 0) {
                $('.promo').remove();
                $('.promo-box').remove();
                return false;
            }

            $('.hours').text((duration.days() * 24) + duration.hours() + 'h');
            $('.minutes').text(duration.minutes() + 'm');
            $('.seconds').text(duration.seconds() + 's.');
        }, interval);
    } else {
        $('.promo-counter').remove();
    }
}



//////////////////
// WEBPACK FOOTER
// ./public/js/lib/countdown.js
// module id = 77
// module chunks = 0